// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1lKXv","bigColWidth":"Table_bigColWidth__3yEck","biggerColWidth":"Table_biggerColWidth__8mEAX","row":"Table_row__5I3_e","col":"Table_col__3UlIL"};